/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetPasswordRequest
 */
export interface SetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof SetPasswordRequest
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof SetPasswordRequest
     */
    password: string;
}

/**
 * Check if a given object implements the SetPasswordRequest interface.
 */
export function instanceOfSetPasswordRequest(value: object): value is SetPasswordRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function SetPasswordRequestFromJSON(json: any): SetPasswordRequest {
    return SetPasswordRequestFromJSONTyped(json, false);
}

export function SetPasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetPasswordRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
        'password': json['password'],
    };
}

export function SetPasswordRequestToJSON(json: any): SetPasswordRequest {
    return SetPasswordRequestToJSONTyped(json, false);
}

export function SetPasswordRequestToJSONTyped(value?: SetPasswordRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
        'password': value['password'],
    };
}

